import * as api from '@tytapp/api';
import { Model } from '../common';
import { MembershipProduct } from './MembershipProduct';

@Model('Offer')
export class Offer extends api.ApiOffer {
    membership_level: MembershipProduct;

    static ROOT_URL = "/membership/offers";
    static API = api.OffersApi;

    get benefitsHtml() {
        return this.htmlSafe('benefits')
    }
}